import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {v4 as uuidv4} from "uuid";
import {ChangeLocalizationValuesCommand} from "./changeLocalizationValues.command";
import {AddImagePackCommand} from "./addImagePack.command";

export class AddUnitCommand extends CommandBase {
    private name: string;
    constructor(name: string = 'New Unit') { super(); this.name = name; }
    execute(data: RemoteConstantsModel): boolean {
        const id = uuidv4();
        data.units.push({
            id: id,
            active: true,
            price: 5,
            score: 1,
            properties: {
                movementSpeed: 1,
                range: 1,
                health: 10,
                attack: 1,
                defense: 1,
                armour: 0,
                regeneration: 2
            },
            attributes: []
        });

        new ChangeLocalizationValuesCommand(id, this.name).execute(data);
        new AddImagePackCommand(id).execute(data);
        return true;
    }
}